module.exports = __webpack_public_path__ + "img/banh.dc36334e.png";